import { Edit, Box, TextField } from "@pankod/refine-mui";
import { useForm } from "@pankod/refine-react-hook-form";

import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";

const schema = Yup.object({
  tier_price_id: Yup.number().label("Tier Price Id").required(),
  duration: Yup.number().label("Duration").required(),
  price: Yup.number().label("Price").required(),
});

interface formDataType {
  tier_price_id: number;
  duration: number;
  price: number;
}

export const TierPriceEdit = () => {
  const {
    saveButtonProps,
    register,
    formState: { errors },
  } = useForm<formDataType>({ resolver: yupResolver(schema) });

  return (
    <Edit canDelete={false} saveButtonProps={saveButtonProps}>
      <Box
        component="form"
        sx={{ display: "flex", flexDirection: "column" }}
        autoComplete="off"
      >
        <TextField
          {...register("tier_price_id")}
          required
          error={!!(errors as any)?.bybit_bot_id}
          helperText={(errors as any)?.bybit_bot_id?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Tier_price_id"
          name="tier_price_id"
          disabled
        />
        <TextField
          {...register("duration")}
          required
          error={!!(errors as any)?.symbol}
          helperText={(errors as any)?.symbol?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Duration"
          name="duration"
        />
        <TextField
          {...register("price")}
          required
          error={!!(errors as any)?.min_usd_start}
          helperText={(errors as any)?.min_usd_start?.message}
          margin="normal"
          fullWidth
          InputLabelProps={{ shrink: true }}
          type="number"
          label="Price"
          name="price"
        />
      </Box>
    </Edit>
  );
};
